// extracted by mini-css-extract-plugin
export var formContainer = "_kb-0";
export var message = "_kb-1";